import { Component, OnInit } from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { DisponibilidadDTO } from 'npm-modelado-catering';
import { DisponibilidadService, PlanificacionCateringService, RequerimientoCateringService } from 'npm-servicios-catering';
import { Router} from '@angular/router';
import { Constantes } from '../../../compartido/constantes/constantes';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Location } from '@angular/common';


@Component({
  selector: 'app-disponibilidad-planificacion-excepcional-listar',
  templateUrl: './disponibilidad-planificacion-excepcional-listar.component.html',
  styleUrls: ['./disponibilidad-planificacion-excepcional-listar.component.css']
})
export class DisponibilidadPlanificacionExcepcionalListarComponent extends LoadingPage implements OnInit {

  lstFechasDisponiblesPlanificacionExcepcional: DisponibilidadDTO[];
  selectedDisponibilidad: DisponibilidadDTO;
  muestraAgregarJefeUnidad: boolean = false;
  busy: Subscription;
  existeRelacionRequerimiento:boolean=false;
  constructor( private  disponibilidadService: DisponibilidadService,
               private confirmationService: ConfirmationService, private planificacionService: PlanificacionCateringService,
                private router: Router, private location: Location, private requerimientosCateringService: RequerimientoCateringService ) { 
    super(true);
  }
  
  ngOnInit() {
    this.cargarEnviroments();
    this.listar();
  }

  cargarEnviroments(){
    this.disponibilidadService.set_constantes(Constantes);
    this.planificacionService.set_constantes(Constantes);
    this.requerimientosCateringService.set_constantes(Constantes);
    this.listar();
  }

  agregarClick(){
      this.router.navigate(['/configuracion/disponibilidad-planificacion-excepcional-crear'])
  }

  buscarRequerimientosCateringPorDisponibilidad(){
    return new Promise(resolve =>{
      this.requerimientosCateringService.buscarExisteRequerimientosCateringPorIdDisponibilidad(this.selectedDisponibilidad.idDisponibilidad).then( responseDisponibilidad =>{  
            this.existeRelacionRequerimiento=responseDisponibilidad;
            resolve(); 
      });
    });
  }

 async eliminarClick(){
    
    if(this.selectedDisponibilidad && this.selectedDisponibilidad.idDisponibilidad){
      await this.buscarRequerimientosCateringPorDisponibilidad();
      if(!this.existeRelacionRequerimiento){
         this.confirmarEliminarDisponibilidad();
      }else{
        this.mostrarMensajeInfo(this._mensajeEliminarDisponibilidadExcepcionalPlanificacion);
      }
    }else{
      this.mostrarMensajeInfo(this._validacionSeleccionResgistro);
    }
  }

  confirmarEliminarDisponibilidad(){
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloEliminarDisponibilidad,
      message: this._indicacionesEliminarExcepcional+ this._saltoLinea+' ¿Está seguro que desea eliminar el registro seleccionado?',
      accept: () => {
        this.eliminarDisponibilidadExcepcional();
      }
    }); 
  }

  verDetalleClick(){
    if (this.selectedDisponibilidad && this.selectedDisponibilidad.idDisponibilidad) {
        
        this.router.navigate(['/configuracion/disponibilidad-planificacion-excepcional-crear'],
        {queryParams :{id : this.selectedDisponibilidad.idDisponibilidad}});
    } else {
        this.mostrarMensajeInfo(this._validacionSeleccionResgistro);
		}
  }

  eliminarDisponibilidadExcepcional(){
      this.disponibilidadService.eliminarFechaDisponibilidad(this.selectedDisponibilidad.idDisponibilidad).then(responseEliminarDisponibilidad=>{
        if(responseEliminarDisponibilidad){
          this.listar();
          this.selectedDisponibilidad=null;
          this.mostrarMensajeInfo(this._objetoEliminarExito);
        }
      }).catch(error => this.mostrarMensajeError(error));
  }
  
  listar(){
    this.busy=this.disponibilidadService.buscarTodosDisponibilidadPlanificacionExcepcional(Constantes.TIPO_DISPONIBILIDAD_EXCEPCIONAL).then(response=>{
      if(response){
        
        this.lstFechasDisponiblesPlanificacionExcepcional= response;
        console.log(this.lstFechasDisponiblesPlanificacionExcepcional)
      }
    }).catch(error => this.mostrarMensajeError(error));
  }
}
